<!--
 * @Author: 黄昱森
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description:
-->
<script>
import ChartBase from '../base.vue';
import { isEmpty } from 'lodash';
import * as echarts from 'echarts/core';
import { DatasetComponent, VisualMapComponent } from 'echarts/components';
import { SunburstChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([DatasetComponent, VisualMapComponent, SunburstChart, CanvasRenderer]);

export default {
  name: 'LcSunBurst',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__sunburst']
    };
  },
  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    convertToTree(flatData, parentId = null) {
      const children = flatData.filter(node => {
        return parentId != null ? node.parentId === parentId : !node.parentId;
      });
      if (!children.length) {
        return [];
      }
      return children.map(node => ({
        ...node,
        children: this.convertToTree(flatData, node.id)
      }));
    },
    processChartData(data) {
      const options = this.mapOptions;
      // 设置了映射字段
      if (!isEmpty(options)) {
        data.forEach(item => {
          item['name'] = item[options?.name];
          item['id'] = item[options?.id];
          item['parentId'] = item[options?.parentId];
          item['value'] = item[options?.valueMap];
        });
      }

      this.chartData = this.convertToTree(data);
    },
    processOptions(options) {
      options.series.data = this.chartData;
      this.chartOptions = options;
    }
  }
};
</script>

<style></style>
